//src/pages/Donate/Donate.styles.ts

import styled from 'styled-components';
import colors from '../../theme/palette'; // Adjust the import path as necessary

export const WhiteBackgroundWrapper = styled.div`
  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  max-width: 1400px;
  margin: 2rem auto;

  @media (max-width: 768px) {
    padding: 0.5rem;
    margin: 0.5rem;
  }
`;

export const ContentWrapper = styled.div`
  background: #ffffff;
  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  padding: 2rem;
  margin: 2rem;
  overflow-y: auto;

  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    padding: 1rem;
    margin: 1rem;
  }
`;

export const DonateSection = styled.section`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;

  h1 {
    font-size: 2.5rem;
    margin-bottom: 1.5rem;
    color: ${(props) => props.theme.primary};
    text-align: center;

    @media (max-width: 768px) {
      font-size: 2rem;
    }
  }

  p {
    text-align: center;
    margin-bottom: 2rem;
    color: ${(props) => props.theme.text};
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
    font-size: 1.2rem;

    @media (max-width: 768px) {
      font-size: 1rem;
      margin-bottom: 1rem;
    }
  }

  button {
    display: block;
    margin: 0 auto;
    padding: 0.75rem 2rem;
    font-size: 1rem;
    font-weight: bold;
    color: ${colors.buttonTextColor};
    background: ${colors.buttonBackground};
    border: none;
    border-radius: 5px;
    transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;
    cursor: pointer;

    &:hover {
      background: ${colors.buttonBackgroundHover};
      transform: translateY(-2px);
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
    }

    &:focus {
      outline: 2px solid ${colors.buttonBackgroundHover};
      outline-offset: 2px;
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
    }

    &:disabled {
      background: ${colors.disabled};
      color: #666;
      cursor: not-allowed;
    }

    @media (max-width: 768px) {
      padding: 0.5rem 1rem;
      font-size: 0.9rem;
    }
  }
`;


export const DonateButton = styled.button`
  background-color: #5469d4;
  color: white;
  padding: 1rem 2rem;
  border: none;
  border-radius: 4px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #4054b2;
  }
`;

export const StripeModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const StripeModalContent = styled.div`
  position: relative;
  background-color: #fff;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  height: 90vh;
  max-height: 800px;
  padding: 1rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

export const CloseButton = styled.button`
  position: absolute;
  top: -40px;
  right: -40px;
  background-color: transparent;
  border: none;
  color: white;
  font-size: 2rem;
  cursor: pointer;
  padding: 0.5rem;
  line-height: 1;
  z-index: 1001;

  &:hover {
    opacity: 0.8;
  }
`;

export const StripeIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;

// Optional: Add a loading state
export const LoadingSpinner = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  // Add your loading spinner styles
`;

// For better user experience, you might want to add a message component
export const MessageOverlay = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  background-color: #4CAF50;
  color: white;
  padding: 1rem;
  border-radius: 4px;
  z-index: 1002;
  animation: slideIn 0.3s ease-out;

  @keyframes slideIn {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }
`;

//StripeIframeStyled

export const StripeIframeStyled = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  background-color: transparent;
`;
